// extracted by mini-css-extract-plugin
export default {"popupHeader":"_2v5k6GWmGRGwyKYgm57YOd","popupBody":"_1py9MAQ1fy6iTU8_rLWny6","popupForm":"_1DiXU0hdl8Qx8o3Hzfw5To"};